/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { LexicalComposer } from '@lexical/react/LexicalComposer';

import { FlashMessageContext } from './context/FlashMessageContext';
import { SettingsContext } from './context/SettingsContext';
import PlaygroundNodes from './nodes/PlaygroundNodes';
import ReadOnlyEditor from './ReadOnlyEditor';
import PlaygroundEditorTheme from './themes/PlaygroundEditorTheme';

export default function EditorWrapper({
  description,
}: {
  description: string;
}): JSX.Element {
  const initial = () => {
    try {
      JSON.parse(description);
      return description;
    } catch (e) {
      return undefined;
    }
  };
  const initialConfig = {
    editorState: initial(),
    namespace: 'Playground',
    editable: false,
    nodes: [...PlaygroundNodes],
    onError: (error: Error) => {
      throw error;
    },
    theme: PlaygroundEditorTheme,
  };

  return (
    <SettingsContext>
      <FlashMessageContext>
        <LexicalComposer initialConfig={initialConfig}>
          <ReadOnlyEditor />
        </LexicalComposer>
      </FlashMessageContext>
    </SettingsContext>
  );
}
